import type { TeamFixture } from '@/lib/network';

/**
 * Short competition tag shown next to a fixture that is NOT a native EPL game
 * (a cup or European tie adopted under the EPL umbrella), so the calendar makes
 * clear which games are not league fixtures. Native fixtures get no tag.
 */
export function fixtureCompetitionTag(
  fixture: Pick<TeamFixture, 'adopted' | 'competitionName'>
): string | null {
  if (!fixture.adopted) {
    return null;
  }
  const name = fixture.competitionName?.trim() ?? '';
  const lower = name.toLowerCase();
  if (/champions league/.test(lower)) return 'UCL';
  if (/europa league/.test(lower)) return 'UEL';
  if (/conference league/.test(lower)) return 'UECL';
  if (/league cup|carabao|efl cup/.test(lower)) return 'LC';
  if (/fa cup/.test(lower)) return 'FAC';
  if (!name) return 'CUP';
  return name
    .split(/\s+/)
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 4);
}
